import { IconEuro } from '@iwoca/icons';
import { Input } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import { turnoverSchema } from './TurnoverScreen.schema';
import { TMobileSignupForm } from '../../form/form';
import { useMobileSignupPersistence } from '../../form/persistence';
import { useScreenValidation } from '../../form/validation/useScreenValidation';
import { StepLayout } from '../../StepLayout/StepLayout';

// DIT-685. Annual turnover (last 12 months). Registers against the shared mobile
// signup form store (DIT-664); the displayed value is formatted with de-DE
// thousands separators — same logic as the desktop TurnoverInputDE.
export const TurnoverScreen = () => {
  const { t } = useLingui();
  const {
    register,
    watch,
    getValues,
    formState: { errors },
  } = useFormContext<TMobileSignupForm>();
  const { putCompanyStage } = useMobileSignupPersistence();
  const { validateAndContinue, isSubmitting, submitError } =
    useScreenValidation(turnoverSchema, () => putCompanyStage(getValues()));

  const amount = watch('last12MonthsTurnover')?.replace(/[^0-9]+/g, '') ?? '';
  const formatted = amount ? parseInt(amount, 10).toLocaleString('de-DE') : '';

  return (
    <StepLayout
      stageTitle={t`Business details`}
      heading={t`Turnover for the last 12 months`}
      onContinue={validateAndContinue}
      loading={isSubmitting}
      submitError={submitError}
    >
      <Input
        {...register('last12MonthsTurnover')}
        type="text"
        inputMode="numeric"
        label={t`Annual turnover`}
        placeholder={t`e.g. 500,000`}
        iconRight={<IconEuro />}
        value={formatted}
        error={errors.last12MonthsTurnover?.message}
      />
    </StepLayout>
  );
};
